.figure {
  margin: 0;
  padding: var(--space-4);
  background: var(--color-bg-muted);
  color: var(--color-text);
}

.caption {
  margin: 0 0 var(--space-4);
  font-size: 0.92rem;
  color: var(--color-text-secondary);
  line-height: 1.5;
}

.layers {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: var(--space-3);
}

.layers > li {
  margin: 0;
}

.layer {
  padding: var(--space-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-elevated);
}

.layerLabel {
  margin: 0 0 var(--space-2);
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-accent);
  font-weight: 560;
}

.items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.35rem;
  font-size: 0.88rem;
  color: var(--color-text-secondary);
  line-height: 1.45;
}

.items > li {
  margin: 0;
}

.note {
  margin: var(--space-4) 0 0;
  font-size: 0.88rem;
  color: var(--color-text-muted);
  line-height: 1.5;
}

@media (min-width: 700px) {
  .layers {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .layer:nth-child(1),
  .layer:nth-child(2) {
    grid-column: span 1;
  }
}

@media (min-width: 980px) {
  .layers {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .layer:nth-child(n) {
    grid-column: span 1;
  }

  .layer:nth-child(7) {
    grid-column: 1 / -1;
  }
}
